import request from '../utils/request'


//卡密查询
export function queryCard(params) {
    return request({
        url: '/cbd/queryCard',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//搜索地点经纬度
export function searchLocation(params) {
    return request({
        url: '/cbd/searchLocation',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//经纬度查询店铺
export function findNear(data) {
    return request({
        url: '/cbd/findNear',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//有城市id搜索关键词获取店铺
export function searchShops(data) {
    return request({
        url: '/cbd/searchShops',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//获取可下单商品列表
export function getCan(params) {
    return request({
        url: '/cbd/getCan',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//商品列表
export function menu(data) {
    return request({
        url: '/cbd/menu',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//获取规格
export function getItem(data) {
    return request({
        url: '/cbd/getItem',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//下单
export function updateTOP(data){
    return request({
        url: '/cbd/order',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//查询订单
export function queryOrder(params){
    return request({
        url: '/cbd/queryOrder',
        method: 'GET',
        params,  // 一般post请求，我们习惯使用 data属性来传参
    })
}

//更新token
export function CBD(data){
    return request({
        url: '/cbd/CBD',
        method: 'POST',
        data,  // 一般post请求，我们习惯使用 data属性来传参
    })
}